<template>
  <gradient-background>
    <center-card>
      <template v-slot:card-title>
        {{$t('forgottenPassword.title')}}
      </template>
      <template v-slot:card-body>
        <forgotten-password-form/>
      </template>
    </center-card>
  </gradient-background>
</template>

<script>
  import GradientBackground from '../layouts/general/GradientBackground.vue';
  import CenterCard from '../layouts/cards/CenterCard.vue';
  import ForgottenPasswordForm from '../components/auth/ForgottenPasswordForm.vue';

  export default {
    components: {
      GradientBackground,
      CenterCard,
      ForgottenPasswordForm,
    },
  };
</script>
